import { Alert } from '@/types/community/alert';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

export const alerts: Alert[] = [
  // Recent alerts (last few days)
  {
    id: 'ALT001',
    title: 'Falta de Energia',
    description: 'Manutenção programada causando falta de energia no Bloco A',
    type: 'maintenance',
    status: 'active',
    block: {
      id: 'BLOCK001',
      name: 'Bloco A'
    },
    startTime: getRelativeDate(-2, 20, 0),
    endTime: getRelativeDate(-2, 22, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT002',
    title: 'Manutenção da Piscina',
    description: 'A piscina estará fechada para limpeza e manutenção',
    type: 'maintenance',
    status: 'active',
    amenity: {
      id: 'AMENITY001',
      name: 'Piscina'
    },
    startTime: getRelativeDate(-1, 8, 0),
    endTime: getRelativeDate(-1, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT003',
    title: 'Teste do Alarme de Incêndio',
    description: 'Teste mensal do sistema de alarme de incêndio será realizado',
    type: 'security',
    status: 'active',
    startTime: getRelativeDate(0, 10, 0),
    endTime: getRelativeDate(0, 11, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT004',
    title: 'Alerta de Segurança',
    description: 'Atividade suspeita relatada na área de estacionamento',
    type: 'security',
    status: 'active',
    startTime: getRelativeDate(-3, 22, 0),
    endTime: getRelativeDate(-2, 6, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT005',
    title: 'Manutenção do Elevador',
    description: 'Elevador no Bloco C estará fora de serviço para manutenção',
    type: 'maintenance',
    status: 'active',
    block: {
      id: 'BLOCK003',
      name: 'Bloco C'
    },
    startTime: getRelativeDate(1, 9, 0),
    endTime: getRelativeDate(1, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past week alerts
  {
    id: 'ALT006',
    title: 'Interrupção do Fornecimento de Água',
    description: 'O fornecimento de água será temporariamente interrompido para reparos de encanamento',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK002',
      name: 'Bloco B'
    },
    startTime: getRelativeDate(-7, 14, 0),
    endTime: getRelativeDate(-7, 16, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT007',
    title: 'Manutenção da Internet',
    description: 'Manutenção programada da internet afetando todos os blocos',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-8, 2, 0),
    endTime: getRelativeDate(-8, 4, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT008',
    title: 'Limpeza do Estacionamento',
    description: 'O estacionamento será limpo e repintado',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-9, 6, 0),
    endTime: getRelativeDate(-9, 14, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT009',
    title: 'Atualização dos Equipamentos da Academia',
    description: 'Instalação de novos equipamentos de academia em andamento',
    type: 'maintenance',
    status: 'resolved',
    amenity: {
      id: 'AMENITY002',
      name: 'Centro de Fitness'
    },
    startTime: getRelativeDate(-12, 8, 0),
    endTime: getRelativeDate(-10, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT010',
    title: 'Atualização de Contato de Emergência',
    description: 'Por favor, atualize suas informações de contato de emergência',
    type: 'other',
    status: 'active',
    startTime: getRelativeDate(-5, 9, 0),
    endTime: getRelativeDate(8, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past month alerts
  {
    id: 'ALT011',
    title: 'Manutenção do Sistema HVAC',
    description: 'Manutenção do sistema de aquecimento e refrigeração em todos os blocos',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-15, 8, 0),
    endTime: getRelativeDate(-15, 16, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT012',
    title: 'Instalação de Câmeras de Segurança',
    description: 'Novas câmeras de segurança sendo instaladas em áreas comuns',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-18, 9, 0),
    endTime: getRelativeDate(-16, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT013',
    title: 'Aviso de Clima',
    description: 'Clima severo esperado - proteja itens ao ar livre',
    type: 'weather',
    status: 'resolved',
    startTime: getRelativeDate(-20, 14, 0),
    endTime: getRelativeDate(-19, 8, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT014',
    title: 'Inspeção de Segurança contra Incêndio',
    description: 'Inspeção anual de segurança contra incêndio será realizada',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-22, 10, 0),
    endTime: getRelativeDate(-22, 15, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT015',
    title: 'Reparos no Telhado',
    description: 'Reparos de emergência no telhado do Bloco D',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK004',
      name: 'Bloco D'
    },
    startTime: getRelativeDate(-25, 7, 0),
    endTime: getRelativeDate(-23, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Older alerts
  {
    id: 'ALT016',
    title: 'Emergência de Encanamento',
    description: 'Problema importante de encanamento no subsolo do Bloco A',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK001',
      name: 'Bloco A'
    },
    startTime: getRelativeDate(-30, 6, 0),
    endTime: getRelativeDate(-29, 20, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT017',
    title: 'Veículo Não Autorizado',
    description: 'Veículo não autorizado estacionado em vaga de residente',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-32, 16, 0),
    endTime: getRelativeDate(-31, 10, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT018',
    title: 'Detecção de Vazamento de Gás',
    description: 'Vazamento de gás detectado no Bloco B - evacuação imediata',
    type: 'emergency',
    status: 'resolved',
    block: {
      id: 'BLOCK002',
      name: 'Bloco B'
    },
    startTime: getRelativeDate(-35, 19, 0),
    endTime: getRelativeDate(-35, 23, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT019',
    title: 'Reunião da Comunidade',
    description: 'Reunião mensal da comunidade no clube',
    type: 'other',
    status: 'resolved',
    startTime: getRelativeDate(-40, 18, 0),
    endTime: getRelativeDate(-40, 20, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT020',
    title: 'Manutenção Anual',
    description: 'Manutenção e inspeção anual do edifício',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-45, 8, 0),
    endTime: getRelativeDate(-43, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 